import axios from "axios";
import { ResetPasswordParams } from "./types/ResetPasswordParams";
import { UserDTO } from "./types/UserDTO";
import { DateRangeParam } from "./types/DateRangeParam";
import { FundOrtModel } from "./types/FundOrtModel";
import { FundModel } from "./types/FundModel";
import { TaxaDTO } from "./types/TaxaDTO";
import { GemeindeModel } from "./types/GemeindeModel";
import { HerbariumModel } from "./types/HerbariumModel";
import { HerbariumPrivatModel } from "./types/HerbariumPrivatModel";
import { OekosystemModel } from "./types/OekosystemModel";
import { DatenquelleModel } from "./types/DatenquelleModel";
import { SubstrateModel } from "./types/SubstrateModel";
import { FundModelAndOrt } from "./types/FundModelAndOrt";
import { GetTableInfoParam } from "./types/GetTableInfoParam";
import { ColumnInfo } from "./types/ColumnInfo";
import { IdGuidParam } from "./types/IdGuidParam";
import { correctDates } from "./helper";

declare var _root_url: string;
function mapUrl(url: string) {
    return _root_url + url;
}

export abstract class AdminController {

  public static async ResetPassword(p: ResetPasswordParams): Promise<void> {
    const result = await axios.post(mapUrl("Admin/ResetPassword"), p);
    return correctDates(result.data);
  }

  public static async GetUsers(): Promise<UserDTO[]> {
    const result = await axios.post(mapUrl("Admin/GetUsers"), );
    return correctDates(result.data);
  }

  public static async GetNewUserCount(): Promise<number> {
    const result = await axios.post(mapUrl("Admin/GetNewUserCount"), );
    return correctDates(result.data);
  }

  public static async UpdateUsers(users: UserDTO[]): Promise<void> {
    const result = await axios.post(mapUrl("Admin/UpdateUsers"), users);
    return correctDates(result.data);
  }

  public static async GetFundOrte(p: DateRangeParam): Promise<FundOrtModel[]> {
    const result = await axios.post(mapUrl("Admin/GetFundOrte"), p);
    return correctDates(result.data);
  }

  public static async GetFunde(p: DateRangeParam): Promise<FundModel[]> {
    const result = await axios.post(mapUrl("Admin/GetFunde"), p);
    return correctDates(result.data);
  }

  public static async GetTaxa(): Promise<TaxaDTO[]> {
    const result = await axios.post(mapUrl("Admin/GetTaxa"), );
    return correctDates(result.data);
  }

  public static async UpdateTaxa(taxas: TaxaDTO[]): Promise<void> {
    const result = await axios.post(mapUrl("Admin/UpdateTaxa"), taxas);
    return correctDates(result.data);
  }

  public static async GetGemeinden(): Promise<GemeindeModel[]> {
    const result = await axios.post(mapUrl("Admin/GetGemeinden"), );
    return correctDates(result.data);
  }

  public static async GetHerbarien(): Promise<HerbariumModel[]> {
    const result = await axios.post(mapUrl("Admin/GetHerbarien"), );
    return correctDates(result.data);
  }

  public static async UpdateHerbarien(herbarien: HerbariumModel[]): Promise<void> {
    const result = await axios.post(mapUrl("Admin/UpdateHerbarien"), herbarien);
    return correctDates(result.data);
  }

  public static async GetHerbarienPrivat(): Promise<HerbariumPrivatModel[]> {
    const result = await axios.post(mapUrl("Admin/GetHerbarienPrivat"), );
    return correctDates(result.data);
  }

  public static async UpdateHerbarienPrivat(herbarien: HerbariumPrivatModel[]): Promise<void> {
    const result = await axios.post(mapUrl("Admin/UpdateHerbarienPrivat"), herbarien);
    return correctDates(result.data);
  }

  public static async UpdateGemeinden(gemeinden: GemeindeModel[]): Promise<void> {
    const result = await axios.post(mapUrl("Admin/UpdateGemeinden"), gemeinden);
    return correctDates(result.data);
  }

  public static async GetOekosysteme(): Promise<OekosystemModel[]> {
    const result = await axios.post(mapUrl("Admin/GetOekosysteme"), );
    return correctDates(result.data);
  }

  public static async UpdateOekosysteme(oekosysteme: OekosystemModel[]): Promise<void> {
    const result = await axios.post(mapUrl("Admin/UpdateOekosysteme"), oekosysteme);
    return correctDates(result.data);
  }

  public static async GetDatenquellen(): Promise<DatenquelleModel[]> {
    const result = await axios.post(mapUrl("Admin/GetDatenquellen"), );
    return correctDates(result.data);
  }

  public static async UpdateDatenquellen(datenquellen: DatenquelleModel[]): Promise<void> {
    const result = await axios.post(mapUrl("Admin/UpdateDatenquellen"), datenquellen);
    return correctDates(result.data);
  }

  public static async GetSubstrate(): Promise<SubstrateModel[]> {
    const result = await axios.post(mapUrl("Admin/GetSubstrate"), );
    return correctDates(result.data);
  }

  public static async UpdateSubstrate(substrate: SubstrateModel[]): Promise<void> {
    const result = await axios.post(mapUrl("Admin/UpdateSubstrate"), substrate);
    return correctDates(result.data);
  }

  public static async UpdateFundOrte(fundOrte: FundOrtModel[]): Promise<void> {
    const result = await axios.post(mapUrl("Admin/UpdateFundOrte"), fundOrte);
    return correctDates(result.data);
  }

  public static async UpdateFunde(funde: FundModelAndOrt[]): Promise<void> {
    const result = await axios.post(mapUrl("Admin/UpdateFunde"), funde);
    return correctDates(result.data);
  }

  public static async GetTableInfo(p: GetTableInfoParam): Promise<ColumnInfo[]> {
    const result = await axios.post(mapUrl("Admin/GetTableInfo"), p);
    return correctDates(result.data);
  }

  public static async DeleteImage(p: IdGuidParam): Promise<any> {
    const result = await axios.post(mapUrl("Admin/DeleteImage"), p);
    return correctDates(result.data);
  }

}
